module.exports = __webpack_public_path__ + "media/images/Download_on_the_App_Store_wht-969642b47a537eefe45f64aaa42f530b.svg";